import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ChevronDown, ChevronUp, MessageCircle, Phone, Mail } from 'lucide-react';
import { supabase } from '../supabase/client';

const faqs = [
  { q: '如何注册账号？', a: '点击首页右上角"注册"按钮，填写手机号和验证码即可完成注册。' },
  { q: '如何购买付费？', a: '进入学员中心，点击"开通付费"，选择适合的付费套餐进行支付。' },
  { q: '支持哪些支付方式？', a: '目前支持微信支付、支付宝支付。' },
  { q: '如何联系客服？', a: '您可以通过页面底部的客服邮箱或电话联系我们。' },
];

export default function HelpCenter() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const [user, setUser] = useState<any>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const checkUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        const { data: profile } = await supabase
          .from('profiles')
          .select('*')
          .eq('id', user.id)
          .single();
        setUser(profile || user);
      }
    };
    checkUser();
  }, []);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    setUser(null);
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <section className="bg-gradient-to-br from-blue-600 via-blue-700 to-indigo-800 text-white py-12">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold mb-2">帮助中心</h2>
          <p className="text-blue-100">常见问题解答与客服支持</p>
        </div>
      </section>

      <section className="py-8">
        <div className="max-w-4xl mx-auto px-6">
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <motion.div key={index} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: index * 0.1 }} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-4 text-left hover:bg-gray-50 transition-colors">
                  <span className="font-medium text-gray-800">{faq.q}</span>
                  {openIndex === index ? <ChevronUp className="w-5 h-5 text-gray-400" /> : <ChevronDown className="w-5 h-5 text-gray-400" />}
                </button>
                {openIndex === index && (
                  <motion.div initial={{ height: 0 }} animate={{ height: 'auto' }} exit={{ height: 0 }} className="overflow-hidden">
                    <div className="p-4 pt-0 text-gray-600 border-t border-gray-100">{faq.a}</div>
                  </motion.div>
                )}
              </motion.div>
            ))}
          </div>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 text-center">
              <div className="w-12 h-12 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <MessageCircle className="w-6 h-6 text-indigo-600" />
              </div>
              <h3 className="font-bold text-gray-800 mb-2">在线客服</h3>
              <p className="text-sm text-gray-500">工作日 9:00-12:00, 14:00-21:00</p>
            </div>
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 text-center">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Phone className="w-6 h-6 text-green-600" />
              </div>
              <h3 className="font-bold text-gray-800 mb-2">客服电话</h3>
              <p className="text-sm text-gray-500">400-123-4567</p>
            </div>
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 text-center">
              <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Mail className="w-6 h-6 text-purple-600" />
              </div>
              <h3 className="font-bold text-gray-800 mb-2">客服邮箱</h3>
              <p className="text-sm text-gray-500">support@udo100.com</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
